import PageRedactionModalContainer from "components/PageRedactionModal/PageRedactionModalContainer";

export default PageRedactionModalContainer;